export default __webpack_public_path__ + "static/media/Y.33d299dd.svg";